import { Component, OnInit } from '@angular/core';
import {InspectionOrder} from "../../../classes/inspectionOrder";
import {ActivatedRoute, Router} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {InspectionOrderService} from "../../../services/inspectionOrder";
import {HttpErrorResponse} from "@angular/common/http";
import {InspectionDeliveryRequest} from "../../../classes/inspectionDeliveryRequest";
import {InspectionDeliveryRequestService} from "../../../services/inspectionDeliveryRequest";

@Component({
  selector: 'app-inspection-delivery-request-create',
  templateUrl: './inspection-delivery-request-create.component.html',
  styleUrls: ['./inspection-delivery-request-create.component.css']
})
export class InspectionDeliveryRequestCreateComponent implements OnInit {

  inspectionDeliveryRequest = new InspectionDeliveryRequest();
  inspectionOrder = new InspectionOrder();
  inspectionDeliveryRequestCreationResult = true;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private modalService: NgbModal,
              private inspectionDeliveryRequestService: InspectionDeliveryRequestService,
              private inspectionOrderService: InspectionOrderService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.inspectionOrderService.getByID(params.get('id'))
          .subscribe({
            next: (inspectionOrder: any) => {
              this.inspectionOrder = inspectionOrder;
            },
            error: (err: HttpErrorResponse) => {
              console.log(err);
            }
          });
    });
  }

  onSubmit() {
    this.inspectionDeliveryRequest.fk_id_inspection_order = this.inspectionOrder.id_inspection_order!;
    this.inspectionDeliveryRequestService.create(this.inspectionDeliveryRequest)
        .subscribe({
          next: () => {
            this.router.navigate(['/inspection/order/' + this.inspectionOrder.id_inspection_order]);
          },
          error: (err: HttpErrorResponse) => {
            this.inspectionDeliveryRequestCreationResult = false;
            console.log(err);
          }
        });
  }

}
